/**
 * @file
 */

import { CreateTHEADSectionGV } from "@/common/common.js";
import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";


var currentNumChildren = 0;
var currentHalfSupport = 0;

export function InitializeRepaymentOptionsPages() {

   // -------------------------------------------------------------------------- 
   // initialize the validation engine                                           
   // -------------------------------------------------------------------------- 
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();



   CreateTHEADSectionGV("GridRePAYE");
   CreateTHEADSectionGV("GridIBR");
   CreateTHEADSectionGV("GridICR");
   CreateTHEADSectionGV("GridISR");
   CreateTHEADSectionGV("GridPAYE");
   CreateTHEADSectionGV("GridGradStandard");
   CreateTHEADSectionGV("GridGradExtended");
   CreateTHEADSectionGV("GridS2");
   CreateTHEADSectionGV("GridS5");


   $("[id*='accordionID']").prop('checked', true);

   var table = $('.responsiveTable').DataTable({
      "responsive": true,
      "scrollX": false,
      "paging": false,
      "searching": false,
      "ordering": false,
      "info": false
   });

   $("[id*='accordionID']").prop('checked', false);


   // ------------------------------------------------------------------------------------
   // when bwr selects Separated from spouse = Yes then default the Reasonable access
   // drop down to no and disable it so it can't be changed.  If the bwr then changes
   // the separated from spouse to No or unselected then make sure the reasonable
   // access dropdown is clear reasonable access and make sure it is enabled for change
   // ------------------------------------------------------------------------------------
   $("[id$='ddlSeparated']").change(function () {
      var selectedValue = $(this).val();

      if (selectedValue == "Y") {
         $("[id$='ddlReasonableAccess']").val("N").prop("disabled", "disabled");
      } else if ((selectedValue == "N") || (selectedValue == "")) {
         $("[id$='ddlReasonableAccess']").val("").removeAttr("disabled");
      }
   });


   // -------------------------------------------------------------------------
   // state of sections 2-4
   // -------------------------------------------------------------------------
   updateSectionState();

   $("[id$='ddlTaxFilingStatus']").change(function () { clearMarriedDropdowns(); updateSectionState(); })
   $("[id$='ddlSeparated']").change(function () { updateSectionState(); })
   $("[id$='ddlReasonableAccess']").change(function () { updateSectionState(); })
   $("[id$='txtNumChildren']").change(function () { updateSectionState(); })
   $("[id$='txtHalfSupport']").change(function () { updateSectionState(); })

   $('input[id$="txtSpouseDOB"]').mask("99-99-9999");

   $(document).tooltip();
};

function clearMarriedDropdowns() {
   $("[id$='ddlSeparated']").val("");
   $("[id$='ddlReasonableAccess']").val("").removeAttr("disabled");
}

function updateSectionState() {
   var vNumChildren = $("[id$='txtNumChildren']").val();
   var vHalfSupport = $("[id$='txtHalfSupport']").val();

   var vTaxFilingStatus = $("[id$='ddlTaxFilingStatus']").val();
   var vSeparated = $("[id$='ddlSeparated']").val();
   var vReasonableAccess = $("[id$='ddlReasonableAccess']").val();

   var dSeparated = $(".separatedFromSpouse");
   var dReasonableAccess = $(".reasonableAccess");
   var dStudentLoanDebt = $(".studentLoanDebt");
   var dSpouseLoanInformation = $('.spouseLoanInformation');
   var dAGIInformation = $('.AGIInformation');
   var dAGIInformationSpouse = $('.AGIInformationSpouse');

   var dAdditionalInputs = $('.additionalInputs');
   var dActionButtons = $('.actionButtons');
   var dOutputSection = $('.outputSection');

   if (vTaxFilingStatus == "") {
      dSeparated.toggleClass("ui-helper-hidden", true);
      dReasonableAccess.toggleClass("ui-helper-hidden", true);
      dAdditionalInputs.toggleClass("ui-helper-hidden", true);
      dStudentLoanDebt.toggleClass("ui-helper-hidden", true);
      dSpouseLoanInformation.toggleClass("ui-helper-hidden", true);
      dAGIInformationSpouse.toggleClass("ui-helper-hidden", true);
      dAGIInformation.toggleClass("ui-helper-hidden", true);
      dActionButtons.toggleClass("ui-helper-hidden", true);
   }
   else {
      // Show the dropdowns for separated from spouse and reasonable access (if married)
      if ((vTaxFilingStatus == "MJ") || (vTaxFilingStatus == "MS")) {
         dSeparated.toggleClass("ui-helper-hidden", false);
         dReasonableAccess.toggleClass("ui-helper-hidden", false);
      } else {
         dSeparated.toggleClass("ui-helper-hidden", true);
         dReasonableAccess.toggleClass("ui-helper-hidden", true);
      }

      if (((currentNumChildren > 0) && (vNumChildren != currentNumChildren)) ||
          ((currentHalfSupport > 0) && (vHalfSupport != currentHalfSupport))) {
         dOutputSection.toggleClass("ui-helper-hidden", true);
      }
      else if ((vNumChildren != "") &&
          (vHalfSupport != "") &&
         ((vTaxFilingStatus == "S") ||
         ((vTaxFilingStatus != "S") && (vSeparated != "") && (vReasonableAccess != "")))) {
         // show section for additional inputs common to all
         dAdditionalInputs.toggleClass("ui-helper-hidden", false);
         dStudentLoanDebt.toggleClass("ui-helper-hidden", false);
         dAGIInformation.toggleClass("ui-helper-hidden", false);
         dActionButtons.toggleClass("ui-helper-hidden", false);

         // show spouse inputs if married filing jointly, not separated, and have reasonable access
         if (((vTaxFilingStatus == "MJ") || (vTaxFilingStatus == "MS")) && (vSeparated == "N") && (vReasonableAccess == "Y")) {
            dSpouseLoanInformation.toggleClass("ui-helper-hidden", false);
            dAGIInformationSpouse.toggleClass("ui-helper-hidden", false);
         } else {
            dSpouseLoanInformation.toggleClass("ui-helper-hidden", true);
            dAGIInformationSpouse.toggleClass("ui-helper-hidden", true);
         }
      } else {
         dAdditionalInputs.toggleClass("ui-helper-hidden", true);
         dStudentLoanDebt.toggleClass("ui-helper-hidden", true);
         dSpouseLoanInformation.toggleClass("ui-helper-hidden", true);
         dAGIInformationSpouse.toggleClass("ui-helper-hidden", true);
         dAGIInformation.toggleClass("ui-helper-hidden", true);
         dOutputSection.toggleClass("ui-helper-hidden", true);
      }
   }

  currentNumChildren = Number(vNumChildren);
  currentHalfSupport = Number(vHalfSupport);
}
